import { computed, Injectable } from '@angular/core';
import { FilterFieldsService } from '@modules/filter/services/filter-fields/filter-fields.service';
import { FilterType } from '@type/filter.type';

@Injectable()
export class LogAdminFieldsService extends FilterFieldsService {
  fields = computed(() => {
    return [
      {
        id: null,
        name: 'created_at',
        field_type: FilterType.Date,
        localized_name: 'Created at',
      },
      {
        id: null,
        name: 'user',
        field_type: FilterType.String,
        localized_name: 'User',
      },
      {
        id: null,
        name: 'super_admin_logs_action',
        field_type: FilterType.Reference,
        localized_name: 'Action',
      },
      {
        id: null,
        name: 'super_admin_logs_loggables',
        field_type: FilterType.Reference,
        localized_name: 'Type',
      },
      {
        id: null,
        name: 'super_admin_logs_field_identifiers',
        field_type: FilterType.Reference,
        localized_name: 'Field Identifier',
      },
      {
        id: null,
        name: 'field_value',
        field_type: FilterType.String,
        localized_name: 'Field Value',
      },
    ];
  });
}
